export default "__VITE_ASSET__B26FaV17__"